import {isFeatureEnabled} from '@github-ui/feature-flags'
import {hpcAttrs} from '@github-ui/hpc'
import {CollapsibleNavList} from '@github-ui/layout-primitives/CollapsibleNavList'
import {CollapsibleSidebar} from '@github-ui/layout-primitives/CollapsibleSidebar'
import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {PlusIcon} from '@primer/octicons-react'
import {PageLayout} from '@primer/react'
import MarketplaceHeader from '@github-ui/marketplace-common/MarketplaceHeader'
import MarketplaceNavigation from '@github-ui/marketplace-common/MarketplaceNavigation'
import type {IndexPayload} from '@github-ui/marketplace-common'
import {SearchAndFilterProviderStack} from '@github-ui/marketplace-common/SearchAndFilterProviderStack'
import {IndexAndSearchContent} from '../components/IndexAndSearchContent'

function MarketplaceSidebarFooter() {
  return (
    <CollapsibleNavList aria-label="Marketplace actions">
      <CollapsibleNavList.LinkItem
        to="/marketplace/new"
        label="Create a new extension"
        icon={PlusIcon}
        forceHardNavigation
      />
      <CollapsibleSidebar.ToggleItem />
    </CollapsibleNavList>
  )
}

export function Index() {
  const payload = useRoutePayload<IndexPayload>()
  const useCollapsibleSidebarLayout = isFeatureEnabled('marketplace_sidebar_layout')

  if (useCollapsibleSidebarLayout) {
    return (
      <SearchAndFilterProviderStack>
        <SidebarPageLayout storageKey="marketplace-sidebar-collapsed">
          <SidebarPageLayout.Header width="full" padding="none">
            <MarketplaceHeader
              as="div"
              leadingAction={
                <SidebarPageLayout.SidebarTrigger aria-label="Open Marketplace categories" variant="default" />
              }
            />
          </SidebarPageLayout.Header>
          <SidebarPageLayout.Sidebar
            aria-label="Marketplace categories"
            dialogTitle="Marketplace categories"
            expandedWidth="medium"
            scrollable
            footer={<MarketplaceSidebarFooter />}
          >
            <MarketplaceNavigation categories={payload.categories} collapsible />
          </SidebarPageLayout.Sidebar>
          <SidebarPageLayout.Content as="div">
            <div {...hpcAttrs()}>
              <IndexAndSearchContent payload={payload} />
            </div>
          </SidebarPageLayout.Content>
        </SidebarPageLayout>
      </SearchAndFilterProviderStack>
    )
  }

  return (
    <SearchAndFilterProviderStack>
      <MarketplaceHeader />
      <div {...hpcAttrs()}>
        <PageLayout>
          <PageLayout.Pane position="start">
            <MarketplaceNavigation categories={payload.categories} />
          </PageLayout.Pane>
          <PageLayout.Content as="div">
            <IndexAndSearchContent payload={payload} />
          </PageLayout.Content>
        </PageLayout>
      </div>
    </SearchAndFilterProviderStack>
  )
}
